import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/services/api.services';
import { AppTabNavigationHeaderComponent } from '../../../../components/navigation-header/app-navigation-header.component';
import { BreadcrumbLabelDirective } from '../../../../directives/breadcrumb-label.directive';

/** Route `data` for the company device and device-group placeholder pages. */
export interface CompanyEntityDetailPlaceholderData {
	title: string;
	message: string;
	automationId: string;
}

/**
 * Placeholder for Company → Devices → a single device or device group.
 * Copy and automation id come from the route so both pages share one component.
 */
@Component({
	selector: 'app-company-entity-detail-placeholder',
	imports: [AppTabNavigationHeaderComponent, BreadcrumbLabelDirective],
	templateUrl: './company-entity-detail-placeholder.component.html',
	styleUrls: ['./company-entity-detail-placeholder.component.scss'],
})
export class CompanyEntityDetailPlaceholderComponent implements OnInit {
	companyId: string;
	entityId: string;
	title: string;
	message: string;
	automationId: string;
	companyName = '';
	breadcrumbLabel = '';

	constructor(
		private readonly route: ActivatedRoute,
		private readonly apiService: ApiService
	) {
		const detail = this.route.snapshot
			.data as unknown as CompanyEntityDetailPlaceholderData;
		this.companyId = this.route.snapshot.params.companyId as string;
		this.entityId = this.route.snapshot.params.id as string;
		this.title = detail.title;
		this.message = detail.message;
		this.automationId = detail.automationId;
	}

	async ngOnInit(): Promise<void> {
		try {
			const response = await this.apiService.getCompanyById(this.companyId);
			this.companyName = response.company?.name ?? '';
			this.breadcrumbLabel = this.companyName;
		} catch {
			this.companyName = '';
			this.breadcrumbLabel = '';
		}
	}
}
